import { render, staticRenderFns } from "./Circle2.vue?vue&type=template&id=37a4af18&scoped=true&"
import script from "./Circle2.vue?vue&type=script&lang=js&"
export * from "./Circle2.vue?vue&type=script&lang=js&"
import style0 from "./Circle2.vue?vue&type=style&index=0&id=37a4af18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a4af18",
  null
  
)

export default component.exports